/* eslint-disable */
/**------------------------------------------------------
 * Type Definitions
 */
export type TypeNgTranslateFunction 		= (value: number, label: EnumNgLabelType) 			=> string;
export type TypeNgCombineLabelsFunction 	= (minLabel: string, maxLabel: string) 				=> string;
export type TypeNgGetLegendFunction	 		= (value: number) 									=> string;
export type TypeNgGetStepLegendFunction 	= (step: INgCustomStepDefinition) 					=> string;
export type TypeNgValueToPositionFunction 	= (val: number, minVal: number, maxVal: number) 	=> number;
export type TypeNgPositionToValueFunction 	= (percent: number, minVal: number, maxVal: number) => number;


/**------------------------------------------------------
 * Enum Definitions
 */
export enum EnumNgLabelType {
	Low 		= 'low',
	High 		= 'high',
	Floor 		= 'floor',
	Ceil 		= 'ceil',
	TickValue 	= 'tickValue'
}

export enum EnumNgPointerType {
	Min 		= 'min',
	Max 		= 'max'
}


/**------------------------------------------------------
 * Interfaces
 */
export interface INgCustomStepDefinition {
	value	: number;
	legend ?: string;
}

export interface INgSliderBaseStyle {
	backgroundPosition	?: string;
	backgroundColor		?: string;
	backgroundImage		?: string;
	backgroundSize		?: string;
}
